import '../tw.css';
import { useTranslation } from "react-i18next";
import ImgCenteredCaption from '../Components/ImgCenteredCaption';
import ImageButton from '../Components/ImageButton';
import { Page } from '../Const/Page';
import { useHistory } from 'react-router-dom';
import { CantoneseIcon, EnglishIcon, MandarinIcon } from '../Components/Icons';
import { GetBodyFontClass, GetHeaderFontClass } from '../Helper/Helper';

export default function HomeGroupPage(){
    const history = useHistory();
    const { t } = useTranslation("homeGroup");
    return <div className='mb-10'>
        <ImgCenteredCaption imageSrc={"https://lccccompany.blob.core.windows.net/public/churchBuilding.jpg"} alt="Church Building">
            <h1 className={`md:text-6xl text-2xl text-center text-white ${GetHeaderFontClass()}`}>{t('title')}</h1>
            <p className={`md:text-2xl text-lg text-center text-white mt-5 ${GetBodyFontClass()}`}>{t('subTitle')}</p>
        </ImgCenteredCaption>
        <div className='flex flex-wrap justify-center mt-3'>
            <ImageButton className={`w-2/3 md:w-1/3 mx-5 md:mx-3 mt-3 md:mt-0 ${GetHeaderFontClass()}`} imageSrc='https://lccccompany.blob.core.windows.net/public/mainhall.jpg'onClick={()=>{history.push(Page.cantoneseHomeGroups)}}>
                <CantoneseIcon className='!text-teal-400'></CantoneseIcon>{t('languages.cantonese.name')}
            </ImageButton>
            <ImageButton className={`w-2/3 md:w-1/3 mx-5 md:mx-3 mt-3 md:mt-0 ${GetHeaderFontClass()}`} imageSrc='https://lccccompany.blob.core.windows.net/public/mainhall.jpg'onClick={()=>{history.push(Page.mandarinHomeGroups)}}>
                <MandarinIcon className='!text-rose-500'></MandarinIcon>{t('languages.mandarin.name')}
            </ImageButton>
            <ImageButton className={`w-2/3 md:w-1/3 mx-5 md:mx-3 mt-3 ${GetHeaderFontClass()}`}  imageSrc='https://lccccompany.blob.core.windows.net/public/emhall.jpg' onClick={()=>{history.push(Page.englishHomeGroups)}}>
                <EnglishIcon className='!text-sky-300'></EnglishIcon>{t('languages.english.name')}
            </ImageButton>
        </div>
    </div>
}
